import { DatePicker } from "@mantine/dates";

export const BaseDatePicker = DatePicker;
